module.exports = __webpack_public_path__ + "h5/img/child-bgd-m.2fddccc8.png";